import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import { makeStyles, Chip, Box } from '@material-ui/core';
import clsx from 'clsx';
import { Typography } from './../../';
import { tokens } from '@getgo/chameleon-core';
const useStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: 8,
        paddingRight: 8,
        fontWeight: theme.typography.fontWeightMedium,
        backgroundColor: 'transparent',
        height: 24,
    },
    withCircleRoot: {
        paddingRight: 0,
    },
    label: {
        paddingLeft: 2,
        paddingRight: 2,
    },
    labelWithCircle: {
        paddingRight: 12,
        paddingLeft: 8,
    },
    incompleteRoot: {
        background: tokens.orange03,
    },
    small: {
        height: 18,
        paddingLeft: 2,
        paddingRight: 2,
    },
    incompleteRootTextOnly: {
        color: tokens.textWarning02,
    },
    emptyRoot: {
        background: tokens.orange03,
    },
    emptyRootTextOnly: {
        color: tokens.textWarning02,
    },
    validRoot: {
        background: tokens.success02,
    },
    validRootTextOnly: {
        color: tokens.textSuccess02,
    },
    pendingRoot: {
        backgroundColor: tokens.warning02,
    },
    pendingRootTextOnly: {
        color: tokens.textWarning02,
    },
    invalidRoot: {
        background: tokens.danger02,
    },
    invalidRootTextOnly: {
        color: tokens.textError01,
    },
    unavailableRoot: {
        background: tokens.uiBase01,
    },
    unavailableRootTextOnly: {
        color: tokens.text02,
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: 4,
        marginTop: 1,
        marginLeft: 2,
        marginRight: theme.spacing(0),
        position: 'relative',
    },
    validCircle: {
        backgroundColor: tokens.presenceAvailable,
    },
    pendingCircle: {
        backgroundColor: tokens.presenceAway,
    },
    invalidCircle: {
        backgroundColor: tokens.presenceBusy,
    },
    unavailableCircle: {
        backgroundColor: tokens.ui03,
    },
    incompleteCircle: {
        backgroundColor: tokens.textWarning02,
        '&::after': {
            content: '""',
            left: 1,
            top: 1,
            position: 'absolute',
            display: 'block',
            width: 6,
            height: 3,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            background: tokens.inverse02,
        },
    },
    emptyCircle: {
        width: 7,
        height: 7,
        borderRadius: 4,
        backgroundColor: tokens.inverse02,
        border: `1px solid ${tokens.orange01}`,
    },
}));
export const StatusChip = forwardRef((_a, ref) => {
    var { label, textOnly = false, withCircle = true, children, size = 'medium', noTextColor = false, variant = 'unavailable', className } = _a, otherProps = __rest(_a, ["label", "textOnly", "withCircle", "children", "size", "noTextColor", "variant", "className"]);
    // Hooks
    const classes = useStyles();
    const variantTranslation = {
        pending: 'Pending',
        invalid: 'Invalid',
        valid: 'Valid',
        unavailable: 'Unavailable',
        incomplete: 'Incomplete',
        empty: 'Empty',
    };
    return (React.createElement(Chip, Object.assign({ innerRef: ref, classes: {
            label: withCircle ? classes.labelWithCircle : classes.label,
        }, className: clsx(classes.root, 
        // @ts-ignore
        !textOnly && classes[`${variant}Root`], withCircle && classes.withCircleRoot, size === 'small' && classes.small, className), size: size, icon: React.createElement(React.Fragment, null, withCircle && (React.createElement(Box, { className: clsx(classes.circle, 
            // @ts-ignore
            classes[`${variant}Circle`]) }))), label: React.createElement(Typography, { variant: size === 'small' ? 'caption-small-02' : 'body-small', className: clsx(textOnly &&
                !noTextColor &&
                // @ts-ignore
                classes[`${variant}RootTextOnly`]) }, label || children || variantTranslation[variant]) }, otherProps)));
});
